'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _plugin = require('@swup/plugin');

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MetaTagsPlugin = function (_Plugin) {
  _inherits(MetaTagsPlugin, _Plugin);

  function MetaTagsPlugin() {
    _classCallCheck(this, MetaTagsPlugin);

    var _this = _possibleConstructorReturn(this, (MetaTagsPlugin.__proto__ || Object.getPrototypeOf(MetaTagsPlugin)).call(this));

    _this.name = 'MetaTagsPlugin';

    _this.getReplaceHead = function () {
      var head = _this.currentHead();
      var newHead = _this.newHead();

      var headTags = ['meta', 'link[itemprop]', 'link[rel="prev"]', 'link[rel="next"]', 'link[rel="canonical"]', 'link[rel="alternate"]', 'link[rel="shortlink"]'].join(',');

      _this.removeCurrent(head, headTags);
      _this.addNew(head, newHead, headTags);

      _this.cleanup(newHead);
    };

    _this.currentHead = function () {
      return document.head;
    };

    _this.newHead = function () {
      var rawHead = _this.swup.cache.getCurrentPage().originalContent.replace('<head', '<div id="swupHead"').replace('</head>', '</div>');

      var head = document.createElement('div');
      head.innerHTML = rawHead;

      return head;
    };

    _this.removeCurrent = function (head, headTags) {
      var tags = head.querySelectorAll(headTags);
      for (var i = 0; i < tags.length; i++) {
        head.removeChild(tags[i]);
      }
    };

    _this.addNew = function (head, newHead, headTags) {
      var tags = newHead.querySelectorAll(headTags);
      for (var i = 0; i < tags.length; i++) {
        head.appendChild(tags[i]);
      }
    };

    _this.cleanup = function (newHead) {
      newHead.innerHTML = '';
      newHead = null;
    };

    return _this;
  }

  _createClass(MetaTagsPlugin, [{
    key: 'mount',
    value: function mount() {
      this.swup.on('contentReplaced', this.getReplaceHead);
    }
  }, {
    key: 'unmount',
    value: function unmount() {
      this.swup.off('contentReplaced', this.getReplaceHead);
    }
  }]);

  return MetaTagsPlugin;
}(_plugin2.default);

exports.default = MetaTagsPlugin;